(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tipset/assets/javascripts/views/bomben-game.js') >= 0) return;  svs.modules.push('/modules/tipset/assets/javascripts/views/bomben-game.js'); 
svs.tipset.views.BombenGame = Backbone.Marionette.View.extend({
  className: 'modal-bottom-padding span12',
  tagName: 'div',
  log: new svs.core.log.Logger('svs.tipset.views.BombenGame'),
  regions: {
    bombenMatches: '#bombenMatches'
  },

  events: {
    'click .js-btn-bomben-system': 'setSystem',
    'click .powerplay-bomben-reload': 'reload'
  },

  modelEvents: {
    change: 'toggleReloadButton'
  },

  initialize: function() {
    svs.tipset.collections.bombenMatches = new svs.tipset.collections.BombenMatches();
  },

  template: function(data) {
    return svs.tipset.templates.bombengame(data);
  },

  toggleReloadButton: function() {
    var bombenReload = $('.powerplay-bomben-reload');
    if (this.model.get('hasXpertValues')) {
      bombenReload.show();
    } else {
      bombenReload.hide();
    }
    this.trigger('modalContentResize');
  },

  onAttach: function() {
    this.toggleReloadButton();
    this.getRegion('bombenMatches').show(
      new svs.tipset.views.BombenMatches({
        collection: svs.tipset.collections.bombenMatches
      })
    );
  },

  setSystem: function(ev) {
    $('.modal-button-right').prop('disabled', false);
    this.model.setSystem($(ev.currentTarget).data('object'));
  },

  reload: function() {
    this.model.reload();
  }
});

 })(window);